import style from './components/style';
import menu from './components/menu';
import carousel from './components/carousel';
import forms from './components/forms';
import select from './components/select';
import animations from './components/animations';

function initHiPriorityCommon() {
	style.init();
}

function initLowPriorityCommon() {
    setTimeout(function() {
        
    }, 1000);
}

function initPage() {
	menu.init();
	carousel.init();
	forms.init();
	select.init();
	animations.init();
}

// document.addEventListener( 'DOMContentLoaded', function () {
window.utils.domReady(function () {
	initHiPriorityCommon();

	window.utils.body.classList.add('page-loaded');

	initPage();
	initLowPriorityCommon();
});
